import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAdminAuthenticated } from "../../utils/adminAuth";

type Props = {
  children: ReactNode;
};

function RequireAdmin({ children }: Props) {
  const location = useLocation();

  if (!isAdminAuthenticated()) {
    return (
      <Navigate to="/admin/login" replace state={{ from: location.pathname }} />
    );
  }

  return <>{children}</>;
}

export default RequireAdmin;
